import { tsCodeSetValue, tsLoginConfig } from '../Typescript/API_Response'

export function getLabelFromList(
  set: any[] | undefined,
  value: string | number | undefined,
  id: string,
  label: string,
) {
  if (set && set.length > 0) {
    const items = set.filter((item) => item?.[id] === value)
    if (items?.length > 0) {
      return items[0]?.[label]
    }
  }
  return ''
}
export function getCodeSetLabelFromList(
  set: tsCodeSetValue[] | undefined,
  codeValue: string | number | undefined,
) {
  return getLabelFromList(set, codeValue, 'CodeValue', 'CodeDescription')
}

export function getSortedCodeSetItems(
  loginConfig: tsLoginConfig | undefined,
  setNames: string[],
) {
  let codeList: tsCodeSetValue[] = []
  setNames.forEach((s) => {
    if (loginConfig?.CodeSets?.[s]) {
      codeList = codeList.concat(loginConfig?.CodeSets[s].values)
    }
  })
  return codeList.sort((a: any, b: any) => a.reqSortOrder - b.reqSortOrder)
}

export function getCodeSetLabelLookup(
  loginConfig: tsLoginConfig | undefined,
  setNames: string[],
  codeValue: string | number | undefined,
) {
  const label = getCodeSetLabelFromList(
    getSortedCodeSetItems(loginConfig, setNames),
    codeValue,
  )
  return label || codeValue
}
